export const buildFlows = (selected: any[], values: any, linkUrl: string) => {
  if (selected?.length) {
    return selected.map((b: any, idx: number) => ({
      responseText: b.multiButton,
      responsePayload: `Join_BUTTON_${idx + 1}_PAYLOAD`,
      delayTimeForNextCard: 0,
      subscriberListName: "",
      responseSubType: "web_url",
      actionFlagDetails: {},
      responseUrlLink: b.linkUrl,
      nextCardId: 0,
      responseType: "BUTTON",
      content_type: "",
      cardId: "1",
      responseTypeId: `webUrlButton${idx}`,
      flowId: `reactflow__edge-1webUrlButton0${idx}`,
    }));
  }

  return [
    {
      responseText: values.buttontext,
      responsePayload: "Join_BUTTON_1_PAYLOAD",
      delayTimeForNextCard: 0,
      subscriberListName: "",
      responseSubType: "web_url",
      actionFlagDetails: {},
      responseUrlLink: values.buttonurl || linkUrl,
      nextCardId: 0,
      responseType: "BUTTON",
      content_type: "",
      cardId: "1",
      responseTypeId: "webUrlButton0",
      flowId: "reactflow__edge-1webUrlButton02",
    },
  ];
};

export const buildBaseTemplateData = ({
  values,
  selected,
  imageUrl,
  imageUrlLink,
  linkUrl,
  fileName,
  buttonCheck,
  pageId,
  editMessage,
}: any) => {
  const flows = buildFlows(selected, values, linkUrl);
  const finalImageUrl = imageUrl || imageUrlLink || "";

  return {
    template: {
      templateName: values.templateName,
      flows,
      firstCardId: "1",
      templateId: editMessage?.templateDetails?.templateId || "1",
      pageId,
      card: [
        {
          textMessage: "Start Node",
          uploadFile: "",
          skipForSubscribers: false,
          delayTimeForNextCard: 0,
          detractorCheck: false,
          isChecked: false,
          supporterCheck: false,
          nextCardId: 1,
          cardId: 0,
          imageUrl: "",
          actionFlag: "",
          randomType: "",
          cardTemplateType: "",
          attachmentId: "",
        },
        {
          textMessage: buttonCheck ? values.messagetext : "",
          fileName: buttonCheck ? "" : fileName || values.fileName,
          cardName: "Card 1",
          subscriberListName: "",
          delayTimeForNextCard: 0,
          mediaChecked: buttonCheck || values.buttonChecked,
          supporterCheck: false,
          randomizer: [],
          genericSubTitle: buttonCheck ? "" : values.messagetext,
          messengerList: "",
          nextCardId: 0,
          imageUrl: buttonCheck ? "" : finalImageUrl,
          cardTemplateType: buttonCheck ? "" : "generic",
          attachmentId: "",
          genericChecked: true,
          uploadFile: "",
          skipForSubscribers: false,
          optinTitle: "",
          detractorCheck: false,
          isChecked: false,
          imgObjKey: "",
          ctatext: "",
          genericTitle: values.headline,
          cardId: 1,
          randomType: "",
        },
      ],
    },
  };
};

export const buildPayload = ({
  isEdit,
  audienceList,
  baseTemplateData,
  pageId,
  adAccountId,
  finalScheduledTime,
  messageTemplateId,
  messageCampaignId,
  templateName,
  excludedCampaignIds,
}: any) => {
  return isEdit
    ? {
        audienceList,
        templateData: baseTemplateData,
        pageId,
        adAccountId,
        messageTemplateId,
        templateStatus: "Draft",
        scheduledTime: finalScheduledTime,
        excludedCampaignIds,
      }
    : {
        audienceList,
        templateData: baseTemplateData,
        pageId,
        adAccountId,
        messageCampaignId,
        templateStatus: "Draft",
        scheduledTime: finalScheduledTime,
        excludedCampaignIds,
      };
};
